module.exports = __webpack_public_path__ + "belarus.svg?ac31b78157e790fbb6968f53103dcc40";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/belarus.svg
// module id = 107
// module chunks = 10